import { render } from "./EditPdp.vue?vue&type=template&id=f5abfbc4&scoped=true"
const script = {}

import "./EditPdp.vue?vue&type=style&index=0&id=f5abfbc4&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5abfbc4"]])

export default __exports__